// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export interface IVsCodeExtensions {
  recommendations?: string[];
}
